<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-auto">
              <p class="text-uppercase text-dark font-weight-bold mb-1">
                {{ $t("sms.votreSolde") }}
              </p>
              <p class="text-gray-5 mb-0">{{ $t("sms.nbrSmsRestant") }}</p>
            </div>
            <p
              class="text-success font-weight-bold font-size-24 mb-0"
              v-if="solde.sms.solde > 100"
            >
              {{ solde.sms.solde }}
            </p>
            <p class="text-danger font-weight-bold font-size-24 mb-0" v-else>
              {{ solde.sms.solde }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-auto">
              <p class="text-uppercase text-dark font-weight-bold mb-1">
                {{ $t("sms.nomlExpediteur") }}
              </p>
              <p class="text-gray-5 mb-0">{{ $t("sms.desclExpediteur") }}</p>
            </div>
            <p class="text-success font-weight-bold font-size-24 mb-0">
              {{ solde.sms.senderName }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <h2 class="badge-example">{{ $t("sms.gererListeDistinateurs") }}</h2>

      <div class="card">
        <div class="card-header">
          <div class="cui__utils__heading mb-0">
            <strong>{{ $t("sms.envoyerDesSms") }}</strong>
          </div>
        </div>
        <div class="card-body">
          <a-form :form="form" class="card-header p-2" @submit="sendSms">
            <div class="row">
              <div class="col-md-12">
                <a-checkbox
                  :checked="checked"
                  @change="handleSelectAll"
                  class="font-weight-bold mb-2"
                >
                  {{ $t("sms.selectAllStudents") }}
                </a-checkbox>
                <div>
                  <label class="typo__label">{{
                    $t("sms.listeVosEleves")
                  }}</label>
                  <multiselect
                    v-model="value"
                    :placeholder="$t('sms.selectionnerEleves')"
                    :selectLabel="$t('sms.pressEnterToSelect')"
                    :options="studentList"
                    :custom-label="customLabel"
                    :close-on-select="false"
                    :preserve-search="true"
                    :maxHeight="700"
                    @input="handleChange"
                    label="_id"
                    track-by="_id"
                    :preselect-first="true"
                    :multiple="true"
                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span
                          class="align-text-top"
                          v-if="props.option.classRoomName"
                        >
                          {{ formatFirstMiddleLast(props.option) }}
                        </span>
                        <span v-else class="text-danger align-text-top">
                          {{ formatFirstMiddleLast(props.option) }}
                        </span>
                        <br /><span class="option__small font-size-12">{{
                          props.option.classRoomName
                            ? props.option.classRoomName
                            : $t("sms.nonInscrit")
                        }}</span>
                      </div>
                    </template>

                    <template slot="noOptions">
                      {{ $t("sms.noOptions") }}
                    </template>
                  </multiselect>
                  <!-- <pre class="language-json"><code>{{ value  }}</code></pre>-->
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 30px">
                <a-checkbox
                  :checked="checkedTeachers"
                  @change="handleSelectAllTeachers"
                  v-if="teacherList"
                  class="font-weight-bold mb-2"
                >
                  {{ $t("sms.selectAllTeachers") }}
                </a-checkbox>
                <div>
                  <label class="typo__label">{{
                    $t("menu.listeEnseignants")
                  }}</label>
                  <multiselect
                    v-model="selectedTeachers"
                    :placeholder="$t('actualite.selectionnerEnseignants')"
                    :selectLabel="$t('sms.pressEnterToSelect')"
                    :options="teacherList"
                    :custom-label="customTeacherLabel"
                    :close-on-select="false"
                    :preserve-search="true"
                    :maxHeight="700"
                    @input="handleTeacherChange"
                    label="_id"
                    track-by="_id"
                    :preselect-first="false"
                    :multiple="true"
                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span
                          class="align-text-top"
                          v-if="props.option.fullName"
                        >
                          {{ props.option.fullName }}
                        </span>
                        <span v-else class="text-danger align-text-top">
                          {{ $t("sms.enseignantSansInfo") }}
                        </span>
                      </div>
                    </template>

                    <template slot="noOptions">
                      {{ $t("sms.noOptions") }}
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 30px">
                <label class="typo__label">{{
                  $t("sms.entrerNumerosSpecifiques")
                }}</label>
                <a-tooltip :title="$t('sms.entrerNumerosSpecifiquesDesc')">
                  <a-icon
                    class="pl-2"
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>

                <a-form-item>
                  <a-textarea
                    @change="handleCustomNumbersChange"
                    v-model="customNumbers"
                    placeholder="+21620111532,+21650215253,+21697147895"
                    allow-clear
                  >
                  </a-textarea>
                  <span class="text-danger">
                    {{ customNumbersValidator }}
                  </span>
                </a-form-item>
              </div>
              <div class="col-md-12">
                <label class="typo__label">{{ $t("sms.categorieTag") }}</label>
                <a-tooltip :title="$t('sms.categorieTagDesc')">
                  <a-icon
                    class="pl-2"
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>
                <a-form-item>
                  <a-select
                    mode="tags"
                    style="width: 100%"
                    :placeholder="$t('sms.saisirCategorieTag')"
                    v-decorator="['tags']"
                  >
                    <a-select-option key="parent">
                      {{ $t("sms.parents") }}
                    </a-select-option>
                    <a-select-option key="personnel">
                      {{ $t("sms.personnel") }}
                    </a-select-option>
                    <a-select-option key="Sanction">
                      {{ $t("sms.sanction") }}
                    </a-select-option>
                    <a-select-option key="Bulletin">
                      {{ $t("sms.bulletin") }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-12 mt-3">
                <label class="typo__label"
                  >{{ $t("sms.contenueVotreMessage") }}
                </label>
                <a-form-item>
                  <a-textarea
                    v-model="message"
                    @change="smsNumber"
                    v-decorator="[
                      'message',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.smsContenue'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('sms.contenueMessage')"
                    :auto-size="{ minRows: 5, maxRows: 10 }"
                    allow-clear
                  />
                </a-form-item>
              </div>
              <div class="col-md-12">
                <a-button
                  type="primary"
                  style="width: 100%"
                  htmlType="submit"
                  size="large"
                  :loading="loadingSms"
                  :disabled="loadingSms"
                  icon="tags"
                  :ghost="false"
                >
                  {{ $t("sms.envoyer") }}
                </a-button>
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <h2 class="badge-example">{{ $t("sms.listeFinale") }}</h2>
      <div class="card">
        <div class="card-body">
          <div :class="$style.head">
            <div :class="$style.headItem" class="mb-3 pr-3">
              <div :class="$style.headIcon" class="bg-light text-dark mr-3">
                <i class="fa fa-comments font-size-18" />
              </div>
              <div>
                <div class="text-uppercase text-muted text-nowrap">
                  {{ $t("sms.nombreSms") }}
                </div>
                <div class="font-weight-bold text-dark">{{ totalSms }}</div>
              </div>
            </div>
            <div :class="$style.headItem" class="mb-3">
              <div :class="$style.headIcon" class="bg-light text-dark mr-3">
                <i class="fa fa-edit font-size-18" />
              </div>
              <div>
                <div class="text-uppercase text-muted text-nowrap">
                  {{ $t("sms.nombreCaracteres") }}
                </div>
                <div class="font-weight-bold text-dark">
                  {{ message.length }}
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <a-checkbox-group
              class="m-2"
              v-model="checkboxValue"
              name="checkboxgroup"
              :options="plainOptions"
              @change="onChange"
            />
            <a-table
              :columns="columns"
              :dataSource="tableData"
              :class="$style.table"
              :pagination="pagination"
              :rowKey="
                (record, index) => record._id || record.customPhone || index
              "
            >
              <template slot="student" slot-scope="text, record">
                <div v-if="record.customPhone">
                  <span
                    v-if="checkboxValue.includes('custom')"
                    class="font-weight-bold"
                    >- - -</span
                  >
                </div>
                <div v-else-if="record.fullName && !record.father">
                  <!-- Teachers should not show in student column -->
                  <span v-if="checkboxValue.includes('teacher')">- - -</span>
                </div>
                <div v-else-if="record.father">
                  <span class="font-weight-bold">
                    {{ customLabel(record) }}
                  </span>
                </div>
              </template>
              <template slot="parent" slot-scope="text, record">
                <div v-if="record.customPhone">
                  <span
                    v-if="checkboxValue.includes('custom')"
                    class="font-weight-bold"
                    >- - -</span
                  >
                </div>
                <div v-else-if="record.fullName && !record.father">
                  <span v-if="checkboxValue.includes('teacher')">
                    {{ record.fullName }}
                    <a-tag color="cyan" class="ml-2">{{
                      $t("emploi.teacher")
                    }}</a-tag>
                  </span>
                </div>
                <div v-else-if="record.father" class="d-flex flex-column">
                  <div v-if="record.father && checkboxValue.includes('father')" class="mb-1">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'father')"
                      @change="(e) => handleStudentParentChange(record._id, 'father', e.target.checked, true)"
                    >
                      <span v-if="record.father.firstName || record.father.lastName">
                        {{ formatFirstMiddleLast(record.father) }}
                        <a-tag color="blue" class="ml-2">{{
                          $t("sms.pere")
                        }}</a-tag>
                      </span>
                      <span v-else>
                        <a-tag color="blue">{{ $t("sms.pere") }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                  <div v-if="record.mother && checkboxValue.includes('mother')">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'mother')"
                      @change="(e) => handleStudentParentChange(record._id, 'mother', e.target.checked, true)"
                    >
                      <span v-if="record.mother.firstName || record.mother.lastName">
                        {{ formatFirstMiddleLast(record.mother) }}
                        <a-tag color="pink" class="ml-2">{{
                          $t("sms.mere")
                        }}</a-tag>
                      </span>
                      <span v-else>
                        <a-tag color="pink">{{ $t("sms.mere") }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                  <div v-if="record.guardian && checkboxValue.includes('guardian')">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'guardian')"
                      @change="(e) => handleStudentParentChange(record._id, 'guardian', e.target.checked, true)"
                    >
                      <span>
                        {{ formatFirstMiddleLast(record.guardian) }}
                        <a-tag color="green" class="ml-2">{{
                          $t("sms.guardian")
                        }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                </div>
              </template>
              <template slot="phone" slot-scope="text, record">
                <div v-if="record.customPhone">
                  <span
                    v-if="checkboxValue.includes('custom')"
                    class="font-weight-bold"
                    >{{ record.customPhone }}</span
                  >
                  <a-tag v-if="checkboxValue.includes('custom') && isDuplicatePhone(record.customPhone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                </div>

                <div v-else-if="record.fullName && !record.father">
                  <span
                    v-if="checkboxValue.includes('teacher')"
                    :class="{
                      'text-danger': record.phone.includes('invalide'),
                    }"
                    class="font-weight-bold"
                    >{{ record.phone }}</span
                  >
                  <a-tag v-if="checkboxValue.includes('teacher') && isDuplicatePhone(record.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                </div>

                <div v-else-if="record.father" class="d-flex flex-column">
                  <div
                    v-if="record.father && checkboxValue.includes('father')"
                    :class="{
                      'text-danger': record.father.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'father'),
                      'text-muted': !getStudentParentSelection(record._id, 'father'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'father') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                    class="mb-1"
                  >
                    {{ record.father.phone }}
                    <a-tag v-if="isDuplicatePhone(record.father.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                  <div
                    v-if="record.mother && checkboxValue.includes('mother')"
                    :class="{
                      'text-danger': record.mother.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'mother'),
                      'text-muted': !getStudentParentSelection(record._id, 'mother'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'mother') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                    class="mb-1"
                  >
                    {{ record.mother.phone }}
                    <a-tag v-if="isDuplicatePhone(record.mother.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                  <div
                    v-if="record.guardian && checkboxValue.includes('guardian')"
                    :class="{
                      'text-danger': record.guardian.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'guardian'),
                      'text-muted': !getStudentParentSelection(record._id, 'guardian'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'guardian') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                  >
                    {{ record.guardian.phone }}
                    <a-tag v-if="isDuplicatePhone(record.guardian.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                </div>
              </template>
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="(c) => (searchInput = c)"
                  :placeholder="`${$t('personnel.chercher')} ${column.title}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block"
                  @change="
                    (e) =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                  >{{ $t("paiement.chercher") }}</a-button
                >
                <a-button
                  size="small"
                  style="width: 90px"
                  @click="() => handleReset(clearFilters)"
                  >{{ $t("action.reinitialiser") }}</a-button
                >
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <!-- SMS Confirmation Modal -->
    <sms-confirm-modal
      :visible="showConfirmModal"
      :loading="loadingSms"
      :summary="finalSmsSummary"
      :totalSms="totalSms"
      @confirm="confirmSend"
      @cancel="showConfirmModal = false"
    />
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { getBuildingCountryCode } from "@/utilities/countrySpecific";
import { normalizePhone, normalizeParentPhones } from "@/utilities/phone";
import SmsConfirmModal from "../components/SmsConfirmModal.vue";
export default {
  components: { SmsConfirmModal },
  computed: {
    ...mapState(["settings"]),
    //...mapGetters("settings", ["btnAccessGetter"]),
    columns() {
      return [
        {
          title: this.$t("profil.student"),
          dataIndex: "firstName",
          key: "student",
          scopedSlots: {
            customRender: "student",
          },
        },
        {
          title: this.$t("sms.destinataire"),
          dataIndex: "father",
          key: "parent",
          scopedSlots: {
            customRender: "parent",
          },
        },
        {
          title: this.$t("sms.telephone"),
          dataIndex: "father.phone",
          class: "bg-transparent text-gray-6",
          scopedSlots: {
            customRender: "phone",
          },
        },
      ];
    },
    plainOptions() {
      return [
        { label: this.$t("sms.pere"), value: "father" },
        { label: this.$t("sms.mere"), value: "mother" },
        { label: this.$t("sms.guardian"), value: "guardian" },
        { label: this.$t("emploi.teacher"), value: "teacher" },
        { label: this.$t("sms.specifique"), value: "custom" },
      ];
    },
    duplicatePhonesSet() {
      const count = {};
      const includeTeacher = this.checkboxValue.includes("teacher");
      const includeCustom = this.checkboxValue.includes("custom");
      this.tableData.forEach((item) => {
        if (item.customPhone) {
          if (includeCustom && this.validPhoneNumber(item.customPhone)) {
            const p = item.customPhone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          return;
        }
        const isTeacher = !item.father && !item.mother && !!item.phone;
        if (isTeacher) {
          if (includeTeacher && this.validPhoneNumber(item.phone)) {
            const p = item.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          return;
        }
        if (item._id && this.studentParentSelections[item._id]) {
          const s = this.studentParentSelections[item._id];
          if (s.father && item.father && this.validPhoneNumber(item.father.phone)) {
            const p = item.father.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          if (s.mother && item.mother && this.validPhoneNumber(item.mother.phone)) {
            const p = item.mother.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          if (s.guardian && item.guardian && this.validPhoneNumber(item.guardian.phone)) {
            const p = item.guardian.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
        }
      });
      const duplicateSet = new Set();
      Object.keys(count).forEach((phone) => {
        if (count[phone] > 1) duplicateSet.add(phone);
      });
      return duplicateSet;
    },
  },
  created() {
    this.form = this.$form.createForm(this, { name: "sendSMSForm" });
    //get solde
    this.getSolde();

    apiClient
      .post("/students/filter", {
        query: {
          status: "active",
        },
        aggregation: [
          {
            $set: {
              classRoom: {
                $convert: {
                  input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                  to: "objectId",
                  onError: null,
                  onNull: null,
                },
              },
            },
          },
          {
            $set: {
              classRoomName: "$classRoom",
            },
          },
          {
            $lookup: {
              from: "classrooms",
              localField: "classRoom",
              foreignField: "_id",
              as: "classRoomName",
            },
          },
          {
            $lookup: {
              from: "parents",
              localField: "parent",
              foreignField: "_id",
              as: "parent",
            },
          },
          {
            $project: {
              _id: 1,
              idParent: { $arrayElemAt: ["$parent._id", 0] },
              father: { $arrayElemAt: ["$parent.father", 0] },
              mother: { $arrayElemAt: ["$parent.mother", 0] },
              guardian: { $arrayElemAt: ["$parent.guardian", 0] },
              classRoom: 1,
              firstName: 1,
              middleName: 1,
              lastName: 1,
              classRoomName: { $arrayElemAt: ["$classRoomName.name", 0] },
            },
          },
        ],
      })
      .then((res) => {
        const { data } = res;
        this.studentList = data.map((e) => {
          // numbers imported without country code get the building dial code
          normalizeParentPhones(e);
          let formatted = { ...e };
          if (e.father) {
            formatted.father.phone = !e.father?.phone
              ? "Pas de numéro"
              : !this.validPhoneNumber(e.father.phone)
              ? e.father.phone + " - invalide"
              : e.father.phone.toString();
          } else {
            formatted.father = {
              phone: "Pas de numéro - invalide",
              login: null,
            };
          }
          if (e.mother) {
            formatted.mother.phone = !e.mother?.phone
              ? "Pas de numéro"
              : !this.validPhoneNumber(e.mother.phone)
              ? e.mother.phone + " - invalide"
              : e.mother.phone.toString();
          } else {
            formatted.mother = {
              phone: "Pas de numéro - invalide",
              login: null,
            };
          }
          if (e.guardian && e.guardian.phone) {
            formatted.guardian.phone = !this.validPhoneNumber(e.guardian.phone)
              ? e.guardian.phone + " - invalide"
              : e.guardian.phone.toString();
          } else {
            formatted.guardian = null;
          }
          formatted.fullName = this.formatFirstMiddleLast(formatted);
          return formatted;
        });
        this.studentsData = _.mapValues(
          _.groupBy(data, "classRoomName"),
          (clist) => clist.map((elem) => _.omit(elem, "classRoomName"))
        );
        this.studentsData["Non inscrit"] = this.studentsData["undefined"];
        delete this.studentsData["undefined"];
      })
      .catch((e) => {
        this.$message.error("Aucun élève est trouvé");
      })
      .finally(() => (this.loadingStudents = false));

    // Fetch teachers
    apiClient
      .get("/teachers")
      .then(({ data }) => {
        this.teacherList = data.map((teacher) => {
          const firstName = teacher.employee?.firstName || "";
          const lastName = teacher.employee?.lastName || "";
          const middleName = teacher.employee?.middleName || "";
          const phone = normalizePhone(teacher.employee?.phone || "");

          let formatted = {
            _id: teacher._id,
            fullName: this.formatFirstMiddleLast({
              firstName,
              middleName,
              lastName,
            }),
            phone: "",
          };

          // Format phone number
          if (phone) {
            formatted.phone = !this.validPhoneNumber(phone)
              ? phone + " - invalide"
              : phone.toString();
          } else {
            formatted.phone = "Pas de numéro - invalide";
          }

          return formatted;
        });
      })
      .catch((e) => {
        this.$message.error("Aucun enseignant trouvé");
      });
  },
  data() {
    return {
      solde: {
        sms: {
          solde: "--",
          senderName: "EdTrust",
        },
      },
      message: "",
      loadingSms: false,
      loadingStudents: true,
      studentsData: [],
      studentList: [],
      teacherList: [],
      value: [],
      selectedTeachers: [],
      tableData: [],
      checkboxValue: [],
      totalSms: 0,
      customNumbers: "",
      customNumbersList: [],
      customNumbersValidator: "",
      pagination: {
        defaultPageSize: 8,
      },
      checked: false,
      checkedTeachers: false,
      // Track per-student parent selections: { studentId: { father: true/false, mother: true/false } }
      studentParentSelections: {},
      // Confirmation modal state
      showConfirmModal: false,
      finalSmsSummary: null,
      pendingSmsPayload: null,
    };
  },
  methods: {
    getSolde() {
      apiClient
        .get("/sms/solde")
        .then((res) => {
          this.solde = res.data;
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        })
        .finally(() => (this.loadingStudents = false));
    },
    moment,
    recomputeTableData() {
      const includeStudents = this.value || [];
      const includeTeachers = this.checkboxValue.includes("teacher")
        ? this.selectedTeachers
        : [];
      const includeCustom = this.checkboxValue.includes("custom")
        ? this.customNumbersList
        : [];

      this.tableData = []
        .concat(includeStudents)
        .concat(includeTeachers)
        .concat(includeCustom);
      this.smsNumber();
    },
    handleSelectAll(e) {
      this.checked = e.target.checked;

      this.value =
        e.target.checked && this.studentList ? [...this.studentList] : [];

      // Initialize parent selections for all selected students - default to all checked
      if (e.target.checked) {
        this.value.forEach((student) => {
          this.$set(this.studentParentSelections, student._id, {
            father: true,
            mother: true,
            guardian: !!student.guardian,
          });
        });
        
        // Ensure global checkboxes are checked when students are selected
        if (this.value.length > 0) {
          if (!this.checkboxValue.includes("father")) {
            this.checkboxValue.push("father");
          }
          if (!this.checkboxValue.includes("mother")) {
            this.checkboxValue.push("mother");
          }
          if (this.value.some((s) => s.guardian) && !this.checkboxValue.includes("guardian")) {
            this.checkboxValue.push("guardian");
          }
        }
      } else {
        // Clear parent selections when deselecting all
        this.studentParentSelections = {};
        // Remove global checkboxes when no students selected
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
      }

      this.recomputeTableData();
    },
    handleSelectAllTeachers(e) {
      this.checkedTeachers = e.target.checked;

      this.selectedTeachers = e.target.checked ? [...this.teacherList] : [];

      // Sync table checkbox with select all
      if (e.target.checked) {
        // Add teacher checkbox if it doesn't exist
        if (!this.checkboxValue.includes("teacher")) {
          this.checkboxValue.push("teacher");
        }
      } else {
        // Remove teacher checkbox when deselecting all
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "teacher"
        );
      }

      this.recomputeTableData();
    },
    ...mapActions("settings", ["packHasBtnAccess"]),

    async sendSms(e) {
      e.preventDefault();

      this.form.validateFieldsAndScroll((err, values) => {
        if (!this.customNumbersValidator)
          if (!err) {
            // Validate that at least one recipient is selected
            const hasTeachers = this.selectedTeachers.length > 0;
            const hasCustomNumbers =
              this.customNumbers.trim().length > 0 &&
              this.customNumbersList.length > 0;

            // Check if any student has at least one parent selected
            const hasStudentParentsSelected = this.value.some((student) => {
              const selections = this.studentParentSelections[student._id];
              if (!selections) return false;
              return selections.father || selections.mother || selections.guardian;
            });

            const hasTeacherSelected =
              hasTeachers && this.checkboxValue.includes("teacher");
            const hasCustomSelected =
              hasCustomNumbers && this.checkboxValue.includes("custom");

            if (
              !hasStudentParentsSelected &&
              !hasTeacherSelected &&
              !hasCustomSelected
            ) {
              this.$message.error(this.$t("sms.noRecipients"));
              return;
            }

            // Build parent phones based on per-student selections
            const parentPhonesMap = new Map(); // idParent -> { _id, father, mother }
            
            this.value.forEach((student) => {
              const selections = this.studentParentSelections[student._id];
              if (!selections) return;

              // Only process if student has a parent ID
              if (!student.idParent) return;

              if (!parentPhonesMap.has(student.idParent)) {
                parentPhonesMap.set(student.idParent, {
                  _id: student.idParent,
                });
              }
              
              const parentEntry = parentPhonesMap.get(student.idParent);
              
              if (selections.father && student.father && student.father !== null && student.father.phone) {
                const fatherPhone = student.father.phone.toString().trim();
                parentEntry.father = { phone: fatherPhone };
              }
              
              if (selections.mother && student.mother && student.mother !== null && student.mother.phone) {
                const motherPhone = student.mother.phone.toString().trim();
                parentEntry.mother = { phone: motherPhone };
              }
              
              if (selections.guardian && student.guardian && student.guardian !== null && student.guardian.phone) {
                const guardianPhone = student.guardian.phone.toString().trim();
                parentEntry.guardian = { phone: guardianPhone };
              }
            });

            let parentPhones = Array.from(parentPhonesMap.values()).filter(
              (p) => p.father || p.mother || p.guardian
            );

            let teacherPhones = this.selectedTeachers.map((t) => {
              return {
                _id: t._id,
                phone: t.phone,
              };
            });

            // Build target array based on actual recipients
            let targetArray = [];
            if (parentPhones.length > 0) {
              // Check if any parent has father, mother or guardian selected
              const hasFather = parentPhones.some((p) => p.father);
              const hasMother = parentPhones.some((p) => p.mother);
              const hasGuardian = parentPhones.some((p) => p.guardian);
              if (hasFather) targetArray.push("father");
              if (hasMother) targetArray.push("mother");
              if (hasGuardian) targetArray.push("guardian");
            }
            if (
              teacherPhones.length > 0 &&
              this.checkboxValue.includes("teacher")
            ) {
              targetArray.push("teacher");
            }
            if (this.customNumbers && this.checkboxValue.includes("custom")) {
              targetArray.push("custom");
            }

            // Store the payload for confirmation
            this.pendingSmsPayload = {
              target: targetArray,
              message: values.message,
              customNumbers: this.checkboxValue.includes("custom")
                ? this.customNumbers
                : "",
              total: this.totalSms,
              tags: values.tags,
              parents: parentPhones,
              teachers: this.checkboxValue.includes("teacher")
                ? teacherPhones
                : [],
            };

            // Compute final numbers summary and show confirmation modal
            this.finalSmsSummary = this.computeFinalSmsSummary();
            this.showConfirmModal = true;
          }
      });
    },
    handleCustomNumbersChange() {
      if (!this.customNumbers || this.customNumbers.trim() === "") {
        this.customNumbersValidator = "";
        this.customNumbersList = [];
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "custom"
        );
        this.recomputeTableData();
        this.smsNumber();
        return;
      }
      if (!this.validCustomePhoneNumbers(this.customNumbers)) {
        this.customNumbersValidator = this.$t("error.smsFormat");
        // Remove custom checkbox if invalid
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "custom"
        );
      } else {
        this.customNumbersValidator = "";
        this.customNumbersList = this.customNumbers
          .split(",")
          .map((e) => ({
            customPhone: normalizePhone(e),
          }))
          .filter((e) => e.customPhone);
        // Add custom checkbox if numbers exist
        if (
          this.customNumbersList.length > 0 &&
          !this.checkboxValue.includes("custom")
        ) {
          this.checkboxValue.push("custom");
        }
        // Remove custom checkbox if no numbers
        if (this.customNumbersList.length === 0) {
          this.checkboxValue = this.checkboxValue.filter(
            (val) => val !== "custom"
          );
        }
        this.recomputeTableData();
      }
      this.smsNumber();
    },
    confirmSend() {
      if (!this.pendingSmsPayload) return;
      this.loadingSms = true;
      apiClient
        .put("/sms", this.pendingSmsPayload)
        .then((res) => {
          this.showConfirmModal = false;
          this.getSolde();
          this.form.resetFields();
          this.value = [];
          this.selectedTeachers = [];
          this.tableData = [];
          this.customNumbers = "";
          this.customNumbersList = [];
          this.checkboxValue = [];
          this.checked = false;
          this.checkedTeachers = false;
          this.studentParentSelections = {};
          this.totalSms = 0;
          this.message = "";
          this.pendingSmsPayload = null;
          this.finalSmsSummary = null;
          this.$message.success(this.$t("success.smsEnvoye"));
        })
        .catch((e) => {
          switch (e.response.status) {
            case 401:
              this.$message.warning(e.response.data.message);
              break;
            default:
              this.$message.error(e.response.data.message);
              break;
          }
        })
        .finally(() => (this.loadingSms = false));
    },
    computeFinalSmsSummary() {
      const seen = new Set();
      const entries = [];
      let totalInvalid = 0;
      let totalDuplicates = 0;

      const addPhone = (phone, label) => {
        if (!phone || !this.validPhoneNumber(phone)) {
          totalInvalid++;
          return null;
        }
        if (seen.has(phone)) {
          totalDuplicates++;
          return null;
        }
        seen.add(phone);
        return { phone, label };
      };

      const parentName = (person, fallbackLabel) => {
        if (!person) return fallbackLabel;
        const n = this.formatFirstMiddleLast(person);
        return n || fallbackLabel;
      };

      // 1. Parent phones: one row per parent (parent name)
      this.value.forEach((student) => {
        const selections = this.studentParentSelections[student._id];
        if (!selections || !student.idParent) return;

        if (selections.father && student.father && student.father.phone) {
          const entry = addPhone(student.father.phone.toString().trim(), this.$t("sms.pere"));
          if (entry) {
            entries.push({
              name: parentName(student.father, this.$t("sms.pere")),
              phones: [entry],
            });
          }
        }

        if (selections.mother && student.mother && student.mother.phone) {
          const entry = addPhone(student.mother.phone.toString().trim(), this.$t("sms.mere"));
          if (entry) {
            entries.push({
              name: parentName(student.mother, this.$t("sms.mere")),
              phones: [entry],
            });
          }
        }

        if (selections.guardian && student.guardian && student.guardian.phone) {
          const entry = addPhone(student.guardian.phone.toString().trim(), this.$t("sms.guardian"));
          if (entry) {
            entries.push({
              name: parentName(student.guardian, this.$t("sms.guardian")),
              phones: [entry],
            });
          }
        }
      });

      // 2. Teacher phones
      if (this.checkboxValue.includes("teacher")) {
        this.selectedTeachers.forEach((teacher) => {
          const phone = teacher.phone ? teacher.phone.toString().trim() : "";
          const entry = addPhone(phone, this.$t("emploi.teacher"));
          if (entry) {
            entries.push({ name: teacher.fullName, phones: [entry] });
          }
        });
      }

      // 3. Custom numbers
      if (
        this.checkboxValue.includes("custom") &&
        this.customNumbersList.length > 0
      ) {
        const customPhones = [];
        this.customNumbersList.forEach((item) => {
          const phone = item.customPhone ? item.customPhone.toString().trim() : "";
          const entry = addPhone(phone, "");
          if (entry) customPhones.push(entry);
        });
        if (customPhones.length > 0) {
          entries.push({
            name: this.$t("sms.specifique"),
            phones: customPhones,
          });
        }
      }

      return { entries, totalValidPhones: seen.size, totalInvalid, totalDuplicates };
    },
    smsNumber() {
      const uniquePhones = new Set();
      const includeTeacher = this.checkboxValue.includes("teacher");
      const includeCustom = this.checkboxValue.includes("custom");

      this.tableData.forEach((item) => {
        // Custom numbers
        if (item.customPhone) {
          if (includeCustom && this.validPhoneNumber(item.customPhone)) {
            uniquePhones.add(item.customPhone.toString().trim());
          }
          return;
        }

        // Teacher rows: no parent fields, has phone
        const isTeacher = !item.father && !item.mother && !!item.phone;
        if (isTeacher) {
          if (includeTeacher && this.validPhoneNumber(item.phone)) {
            uniquePhones.add(item.phone.toString().trim());
          }
          return;
        }

        // Student's parents - check per-student selections
        if (item._id && this.studentParentSelections[item._id]) {
          const selections = this.studentParentSelections[item._id];

          if (selections.father && item.father && this.validPhoneNumber(item.father.phone)) {
            uniquePhones.add(item.father.phone.toString().trim());
          }

          if (selections.mother && item.mother && this.validPhoneNumber(item.mother.phone)) {
            uniquePhones.add(item.mother.phone.toString().trim());
          }

          if (selections.guardian && item.guardian && this.validPhoneNumber(item.guardian.phone)) {
            uniquePhones.add(item.guardian.phone.toString().trim());
          }
        }
      });
      this.calculateSMSNumber(uniquePhones.size);
    },
    calculateSMSNumber(total) {
      if (this.isArabic(this.message))
        this.totalSms = Math.ceil(this.message.length / 66) * total;
      else this.totalSms = Math.ceil(this.message.length / 156) * total;
    },
    formatFirstMiddleLast(p) {
      if (!p) return "";
      const parts = [p.firstName, p.middleName, p.lastName]
        .map((x) => (x != null && String(x).trim() ? String(x).trim() : ""))
        .filter(Boolean);
      return parts.join(" ");
    },
    customLabel({ firstName, middleName, lastName }) {
      return this.formatFirstMiddleLast({ firstName, middleName, lastName });
    },
    customTeacherLabel(teacher) {
      return teacher.fullName || "Enseignant sans info";
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(value) {
      this.checked = value.length === this.studentList.length;

      // Get previously selected student IDs
      const previousIds = new Set(this.value.map((s) => s._id));
      const currentIds = new Set(value.map((s) => s._id));

      // Initialize parent selections for newly selected students - default to all checked
      value.forEach((student) => {
        // Only set defaults for newly added students, preserve existing selections
        if (!this.studentParentSelections[student._id]) {
          this.$set(this.studentParentSelections, student._id, {
            father: true,
            mother: true,
            guardian: !!student.guardian,
          });
        }
      });

      // Remove parent selections for deselected students
      const newSelections = {};
      Object.keys(this.studentParentSelections).forEach((studentId) => {
        if (currentIds.has(studentId)) {
          newSelections[studentId] = this.studentParentSelections[studentId];
        }
      });
      this.studentParentSelections = newSelections;

      // Ensure global checkboxes are checked when students are selected
      if (value.length > 0) {
        if (!this.checkboxValue.includes("father")) {
          this.checkboxValue.push("father");
        }
        if (!this.checkboxValue.includes("mother")) {
          this.checkboxValue.push("mother");
        }
        if (value.some((s) => s.guardian) && !this.checkboxValue.includes("guardian")) {
          this.checkboxValue.push("guardian");
        }
      } else {
        // Remove global checkboxes when no students selected
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
      }

      this.recomputeTableData();
    },
    handleTeacherChange(value) {
      this.checkedTeachers =
        value.length === (this.teacherList ? this.teacherList.length : 0);

      // Automatically check "teacher" checkbox in the table when teachers are selected
      if (value.length > 0) {
        if (!this.checkboxValue.includes("teacher")) {
          this.checkboxValue.push("teacher");
        }
      } else {
        // Remove teacher checkbox if no teachers are selected
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "teacher"
        );
      }

      this.recomputeTableData();
    },
    //a table
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    isArabic(text) {
      let pattern = /[\u0600-\u06FF\u0750-\u077F]/;
      return pattern.test(text);
    },
    //checkbot
    onChange(checkedValues) {
      // When global checkboxes change, update all student selections
      const includeFather = checkedValues.includes("father");
      const includeMother = checkedValues.includes("mother");
      const includeGuardian = checkedValues.includes("guardian");
      
      // Update all selected students' parent selections based on global checkboxes
      this.value.forEach((student) => {
        this.$set(this.studentParentSelections, student._id, {
          father: includeFather,
          mother: includeMother,
          guardian: includeGuardian && !!student.guardian,
        });
      });
      
      this.recomputeTableData();
    },
    // Handle per-student parent checkbox changes
    handleStudentParentChange(studentId, parentType, checked, updateGlobal = false) {
      if (!this.studentParentSelections[studentId]) {
        this.$set(this.studentParentSelections, studentId, {
          father: false,
          mother: false,
          guardian: false,
        });
      }
      this.$set(this.studentParentSelections[studentId], parentType, checked);
      
      // Update global checkbox state based on individual selections
      if (updateGlobal) {
        this.updateGlobalCheckboxes();
      }
      
      this.recomputeTableData();
    },
    // Update global checkboxes based on individual student selections
    updateGlobalCheckboxes() {
      if (this.value.length === 0) {
        // If no students selected, uncheck global checkboxes
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
        return;
      }
      
      // Helper function to update a parent type checkbox
      const updateParentCheckbox = (parentType) => {
        const allSelected = this.value.every((student) => {
          const selections = this.studentParentSelections[student._id];
          return selections && selections[parentType];
        });
        
        const someSelected = this.value.some((student) => {
          const selections = this.studentParentSelections[student._id];
          return selections && selections[parentType];
        });
        
        if (allSelected && !this.checkboxValue.includes(parentType)) {
          this.checkboxValue.push(parentType);
        } else if (!someSelected && this.checkboxValue.includes(parentType)) {
          this.checkboxValue = this.checkboxValue.filter((val) => val !== parentType);
        }
      };
      
      // Update father, mother and guardian checkboxes
      updateParentCheckbox("father");
      updateParentCheckbox("mother");
      updateParentCheckbox("guardian");
    },
    // Get per-student parent selection
    getStudentParentSelection(studentId, parentType) {
      if (!this.studentParentSelections[studentId]) {
        return false;
      }
      return this.studentParentSelections[studentId][parentType] || false;
    },
    isDuplicatePhone(phone) {
      if (!phone) return false;
      const p = phone.toString().trim();
      return this.validPhoneNumber(phone) && this.duplicatePhonesSet.has(p);
    },
    validPhoneNumber(phone) {
      if (!phone) return false;
      const p = phone.toString().trim();
      if (getBuildingCountryCode() === "TN") {
        // Tunisia: +216 followed by 8 digits (first digit non-zero)
        return /^\+216[1-9]\d{7}$/.test(p);
      }
      // Generic E.164 for other countries
      return /^\+[1-9]\d{6,14}$/.test(p);
    },
    validCustomePhoneNumbers(phones) {
      // numbers without country code get the building dial code
      const list = phones
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);
      return list.length > 0 && list.every((p) => this.validPhoneNumber(normalizePhone(p)));
    },
  },
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
